




































































import Enumerable from "linq";
import { Component, Mixins, Model, Prop, Emit } from "vue-property-decorator";
import ReferenceCommentListTabSelector from "../../../../components/workflow/selectors/ReferenceCommentListTabSelector.vue";
import { FixedLoading, instanceOfITreeExpandable } from "../../../system";
import CacheableComponent from "../../../system/CacheableComponent.vue";
import TabSelector from "../../../system/selectors/TabSelector.vue";
import { instanceOfIEditFixedPhrase } from "../../../document/fixedPhrase";
import {
  ReceptionUserFixedPhraseSelector,
  ReceptionDepartmentFixedPhraseSelector,
} from "./fixedPhrase/selectors";
import { FixedPhraseReference } from "../../../../domain/document";
import { IReferenceCommentListTableCondition } from "../../lists/tables/IReferenceCommentListTableCondition";

interface ICommentEditorTemplateTab {
  name: string;
  description: string;
  componentName: string;
}

export interface ICommentEditor {
  focus(): void;
  setSelectionRange(start: number, end: number, direction?: "forward" | "backward" | "none"): void;
}

export function instanceOfICommentEditor(instance: any): instance is ICommentEditor {
  return instance
    && (typeof instance.focus === "function")
    && (typeof instance.setSelectionRange === "function");
}

@Component({
  components: {
    CacheableComponent,
    TabSelector,
    ReceptionUserFixedPhraseSelector,
    ReceptionDepartmentFixedPhraseSelector,
    ReferenceCommentListTabSelector,
    FixedLoading,
  }
})
export default class CommentEditor extends Mixins() implements ICommentEditor {
  @Model("input")
  value: string;

  @Prop({ default: false })
  readonly: boolean;

  @Prop()
  commentLabel: string;

  @Prop()
  shouldEmphasizeInput: boolean;

  @Prop()
  referenceCondition: IReferenceCommentListTableCondition;

  @Emit()
  input(value: string): void {}

  data(): any {
    return {
      selectedTemplateTab: null as ICommentEditorTemplateTab,
      selectedUserFixedPhrase: null as FixedPhraseReference,
      selectedDepartmentFixedPhrase: null as FixedPhraseReference,
      isFixedPhraseEditing: false,
    };
  }
  selectedTemplateTab: ICommentEditorTemplateTab;
  selectedUserFixedPhrase: FixedPhraseReference;
  selectedDepartmentFixedPhrase: FixedPhraseReference;
  isFixedPhraseEditing: boolean;

  mounted(): void {
    this.setSelectedTemplateTab();
  }

  private get templateTabs(): ICommentEditorTemplateTab[] {
    return [
      { name: "個人", description: "個人の定型文を表示します。", componentName: "receptionUserFixedPhraseSelector" },
      { name: "主" + this.$wording.common.departmentAsShort, description: "主" + this.$wording.common.departmentAsShort + "の定型文を表示します。", componentName: "receptionDepartmentFixedPhraseSelector" },
    ];
  }

  setSelectedTemplateTab(): void {
    this.selectedTemplateTab = this.templateTabs[0];
  }

  get editedText(): string {
    return this.value;
  }

  set editedText(value: string) {
    this.input(value);
  }

  get userId(): string {
    return this.$store.getters.user.id;
  }

  get departmentId(): string {
    return this.$store.getters.department
      ? this.$store.getters.department.id
      : null;
  }

  get isAdministratorDepartment(): boolean {
    return this.departmentId && Enumerable.from(this.$store.getters.userAuthority.administratorDepartmentIds as string[])
      .any(d => d === this.departmentId);
  }

  get isEditFixedPhrase(): boolean {
    return this.shouldShowTemplateTabContent("個人") ||
      (this.isAdministratorDepartment && this.shouldShowTemplateTabContent("主" + this.$wording.common.departmentAsShort));
  }

  get selectedFixedPhrase(): FixedPhraseReference {
    return this.shouldShowTemplateTabContent("個人")
      ? this.selectedUserFixedPhrase
      : this.selectedDepartmentFixedPhrase;
  }

  get message(): string {
    return this.editedText
      ? ""
      : this.commentLabel + "を入力してください。";
  }

  get textareaClearClassName(): string {
    return this.shouldEmphasizeInput
      ? "comment-editor-textarea-clear"
      : "comment-editor-textarea-clear full-width";
  }

  get isExpandButtonVisible(): boolean {
    return !this.$configuration.behavior.fixedPhrase.shouldExpandTreeAutomatically;
  }
  
  focus(): void {
    const textarea = this.$refs.textarea as HTMLTextAreaElement;
    textarea.focus();
  }

  setSelectionRange(start: number, end: number, direction?: "forward" | "backward" | "none"): void {
    const textarea = this.$refs.textarea as HTMLTextAreaElement;
    textarea.setSelectionRange(start, end, direction);
  }

  expandTree(): void {
    const tree = this.$refs[this.selectedTemplateTab.componentName];
    if (instanceOfITreeExpandable(tree)) {
      tree.expandTree();
    }
  }

  async pasteFixedPhrase(): Promise<void> {
    const phrase = this.selectedFixedPhrase
      ? this.selectedFixedPhrase.text
      : null;
    if (!phrase) { return; }
    const textarea = this.$refs.textarea as HTMLTextAreaElement;
    const text = textarea.value;
    const selectionStart = textarea.selectionStart;
    const selectionEnd = textarea.selectionEnd;
    this.editedText = text.slice(0, selectionStart) + phrase + text.slice(Math.max(selectionStart, selectionEnd));
    const insertedIndex = selectionStart + phrase.length;
    await this.$nextTick();
    this.focus();
    this.setSelectionRange(insertedIndex, insertedIndex);
  }

  dragStart(event: DragEvent, text: string): void {
    event.dataTransfer.effectAllowed = "copy";
    event.dataTransfer.setData("text", text);
  }

  dragOver(event: DragEvent): void {
    event.stopPropagation();
    event.dataTransfer.effectAllowed = "copy";
  }

  editFixedPhrase(): void {
    const tree = this.$refs[this.selectedTemplateTab.componentName];
    if (instanceOfIEditFixedPhrase(tree) && !this.isFixedPhraseEditing) {
      this.isFixedPhraseEditing = true;
      tree.editFixedPhrase()
      .finally(() => {
        this.isFixedPhraseEditing = false;
      });
    }
  }

  clearTextarea(): void {
    this.editedText = "";
    this.focus();
  }

  shouldShowTemplateTabContent(name: string): boolean {
    return this.selectedTemplateTab && (this.selectedTemplateTab.name === name);
  }

  contextmenu(e: PointerEvent) {
    this.$showTextInputContextMenu(e);
  }
}
